import { Component } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-testimonials-section',
  templateUrl: './testimonials-section.component.html',
  styleUrl: './testimonials-section.component.scss',
  standalone: true,
  imports: [SharedModule, MatIconModule],
})
export class TestimonialsSectionComponent {
  selectedIndex = 0;

  testimonies: any[] = [
    {
      id: 0,
      name: 'Herieth Jordan',
      role: 'ICT Officer',
      institution: 'e-Government Authority',
      logo: '../../../../assets/images/landing/institutions/ega_logo.png',
      rating: 5,
      content:
        "The most stable meeting platform we've ever used. HD quality holds up even on weak connections, and integrating eMikutano into our scheduling workflow saved us over ten hours a week in administrative overhead.",
    },
    {
      id: 1,
      name: 'Jane Doe',
      role: 'ICT Director',
      institution: 'Parliament of Tanzania',
      logo: '../../../../assets/images/landing/institutions/bunge.png',
      rating: 5,
      content:
        "Sovereign hosting was non-negotiable for us. eMikutano gave us the compliance posture we needed without compromising on the experience our members expect from a modern meeting platform.",
    },
    {
      id: 2,
      name: 'John Smith',
      role: 'Head of Operations',
      institution: 'TCRA',
      logo: '../../../../assets/images/landing/institutions/TCRA.png',
      rating: 5,
      content:
        "Reservations and room scheduling across our branches used to be a daily headache. One calendar, zero double-bookings — the switch paid for itself in the first quarter.",
    },
    {
      id: 3,
      name: 'Amin Kunambi',
      role: 'Systems Administrator',
      institution: 'e-Government Authority',
      logo: '../../../../assets/images/landing/institutions/ega_logo.png',
      rating: 5,
      content:
        "Rolling out a branded instance for our agency took a single afternoon. The team support is responsive and the platform just works — exactly what we needed for a national rollout.",
    },
  ];

  logos: string[] = [
    '../../../../assets/images/landing/institutions/ega_logo.png',
    '../../../../assets/images/landing/institutions/bunge.png',
    '../../../../assets/images/landing/institutions/TCRA.png',
    '../../../../assets/images/landing/institutions/ega_logo.png',
    '../../../../assets/images/landing/institutions/bunge.png',
    '../../../../assets/images/landing/institutions/TCRA.png',
  ];

  select(i: number) {
    this.selectedIndex = i;
  }

  stars(rating: number): number[] {
    return Array(rating).fill(0);
  }

  get active() {
    return this.testimonies[this.selectedIndex];
  }
}
